/**
 * Iter-60 — Mobile top header (hamburger + app name).
 *
 * Only rendered on mobile viewports by `Layout.jsx`. Provides:
 *   * Hamburger button → opens the shared `MobileNavDrawer`.
 *   * Platform name / current section title in the centre.
 *   * Right-side slot for optional per-role controls.
 *
 * On desktop this component is hidden (`md:hidden`).
 */
import React from "react";
import { List } from "@phosphor-icons/react";

export default function MobileHeader({
  onOpenNav,
  title,
  right = null,
  ariaControls = "mobile-nav-drawer",
}) {
  return (
    <header
      className="md:hidden sticky top-0 z-40 flex items-center gap-2 border-b border-black bg-white px-3 py-2"
      data-testid="mobile-header"
    >
      <button
        type="button"
        onClick={onOpenNav}
        aria-label="Open navigation menu"
        aria-expanded="false"
        aria-controls={ariaControls}
        className="w-11 h-11 flex items-center justify-center border border-black hover:bg-black hover:text-white"
        data-testid="mobile-nav-open"
      >
        <List size={20} weight="bold" />
      </button>
      <div className="font-chivo font-black uppercase tracking-tighter text-lg truncate flex-1">
        {title}
      </div>
      {right}
    </header>
  );
}
